import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { createUserWithEmailAndPassword, updateProfile } from 'firebase/auth';
import { Header } from '../../components/Header/Header';
import { Footer } from '../../components/Footer/Footer';
import { auth } from '../../../service/firebase';
import { upsertUserProfile } from '../../../service/userService';
import './Auth.css';

const Register = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleRegister = async (event) => {
    event.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { user } = await createUserWithEmailAndPassword(auth, email, password);
      if (user && name.trim()) {
        await updateProfile(user, { displayName: name.trim() });
      }
      await upsertUserProfile({ ...user, displayName: name.trim() || user?.displayName });
      navigate('/');
    } catch (authError) {
      console.error('Erro ao cadastrar usuário', authError);
      setError('Não foi possível concluir o cadastro. Verifique os dados digitados.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <div className="body">
        <div className="center">
          <div className="body-content card auth-card">
            <div className="topo-page">
              <strong># Cadastro</strong>
            </div>
            <p className="auth-description">
              Defina seus dados para sincronizar partidas em qualquer dispositivo.
            </p>
            <form className="auth-form" onSubmit={handleRegister}>
              {error && (
                <p className="auth-error" role="alert">
                  {error}
                </p>
              )}
              <label htmlFor="register-name">Nome</label>
              <input
                id="register-name"
                type="text"
                placeholder="Seu nome completo"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />

              <label htmlFor="register-email">Email</label>
              <input
                id="register-email"
                type="email"
                placeholder="seuemail@exemplo.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />

              <label htmlFor="register-password">Senha</label>
              <input
                id="register-password"
                type="password"
                placeholder="********"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />

              <button type="submit" className="btn-default" disabled={loading}>
                {loading ? 'Salvando...' : 'Criar conta'}
              </button>
            </form>
            <div className="auth-footer">
              <span>Já possui conta?</span>
              <Link to="/login">Fazer login</Link>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Register;
